export default "__VITE_ASSET__DbKJjBFG__"